<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 15 18"
  fill="none"
>
  <path
    d="M9.75 1.5V5.25H13.5V16.5H1.5V1.5H9.75ZM10.5 0H0V18H15V4.5L10.5 0Z"
    [attr.fill]="color"
  />
</svg>
